import React, { useEffect, useState } from 'react';
import CustomModal from './CustomModal';
import './ConsolidateModal.css';

const ConsolidateModal = ({ consolidateModalOpen, closeModal, handleBulkConsolidateSubmit }) => { 
    const [tags, setTags] = useState("");

    const handleTagsChange = (e) => {
        setTags(e.target.value);
    };

    useEffect(() => {
        if (consolidateModalOpen) {
            setTags("");
        }
    }, [consolidateModalOpen]);

    return (
        <CustomModal
        isOpen={consolidateModalOpen}
        onRequestClose={closeModal}
        overlayClassName="modal-overlay"
        modalClassName="modal-base"
        headerContent={<h3>Consolidate</h3>}
        bodyContent={
            <div></div>
        }
        footerContent={
            <div className="modal-footer-content">
            <div className="footer-tags-container">
              <label>Add Tags (Comma Separated):</label>
              <input
                type="text"
                value={tags}
                onChange={handleTagsChange}
              />
            </div>
            <div className="footer-buttons">
              <button onClick={() => handleBulkConsolidateSubmit(tags)}>Submit</button>
              <button onClick={closeModal}>Close</button>
            </div>
          </div>
        }     
        />
    );
};

export default ConsolidateModal;
